import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// import { configureStore } from '@reduxjs/toolkit';

// reducer import

import { userReducerSlice } from "./slices/userSlice";
// import { farmerTasksReducerSlice } from "./slices/farmerTasksSlices";
import { farmerReducerSlice } from "./slices/farmersSlices";
import { consultantReducerSlice } from "./slices/consultantsSlices";
import { supplierReducerSlice } from "./slices/suppliersSlices";
import { productReducerSlice } from "./slices/productsListsSlices";
import { cropReducerSlice } from "./slices/cropSlices";
import { adminReducerSlice } from "./slices/adminSlices";
import { complainReducerSlice } from "./slices/complainSlices";
import { assignedtasksReducerSlice } from "./slices/farmerTasksSlices";
import { tenantsReducerSlice } from "./slices/tenantSlices";

// ==============================|| COMBINE REDUCER ||============================== //

const persistUserConfig = {
  key: "User",
  storage,
};
// const farmerPersistConfig = {
//   key: "Farmer",
//   storage,
// };
// const consultantPersistConfig = {
//   key: "Consultant",
//   storage,
// };
// const supplierPersistConfig = {
//   key: "Supplier",
//   storage,
// };

// const farmerTasksPersistConfig = {
//   key: "FarmerTasks",
//   storage,
// };

const adminDataPersistConfig = {
  key: "adminData",
  storage,
};

const tenantsDataPersistConfig = {
  key: "tenantsData",
  storage,
};

const complainPersistConfig = {
  key: "complain",
  storage,
};

const assignedtasksPersistConfig = {
  key: "assignedtasks",
  storage,
};

const persistedUserReducer = persistReducer(
  persistUserConfig,
  userReducerSlice
);
// const persistedFarmerReducer = persistReducer(
//   farmerPersistConfig,
//   farmerReducerSlice
// );
// const persistedConsultantReducer = persistReducer(
//   consultantPersistConfig,
//   consultantReducerSlice
// );
// const persistedSupplierReducer = persistReducer(
//   supplierPersistConfig,
//   supplierReducerSlice
// );

// const persistedFarmerTasksReducer = persistReducer(
//   farmerTasksPersistConfig,
//   farmerTasksReducerSlice
// );

const persistedadminReducer = persistReducer(
  adminDataPersistConfig,
  adminReducerSlice
);

const persistedComplainReducer = persistReducer(
  complainPersistConfig,
  complainReducerSlice
);

const persistedAssignedtasksReducer = persistReducer(
  assignedtasksPersistConfig,
  assignedtasksReducerSlice
);

const persistedTenantsReducer = persistReducer(
  tenantsDataPersistConfig,
  tenantsReducerSlice
);

const reducer = combineReducers({
  user: persistedUserReducer,
  farmer: farmerReducerSlice,
  consultant: consultantReducerSlice,
  supplier: supplierReducerSlice,
  product: productReducerSlice,
  crop: cropReducerSlice,
  // farmerTasks: persistedFarmerTasksReducer,
  assignedtasks: persistedAssignedtasksReducer,
  admin: persistedadminReducer,
  tenants: persistedTenantsReducer,
  complain: persistedComplainReducer,
});

export default reducer;
